
import { EditableProTable } from '@ant-design/pro-table';
import shortid from 'shortid';
import { useTranslation, Trans } from 'react-i18next';
import { addFgAccountingItems, getFgAccountingItems } from '../util/APIUtils';
import { SaveTwoTone, SaveOutlined, EditTwoTone, DeleteTwoTone, CloseCircleTwoTone  } from '@ant-design/icons';
import React, { useState, useEffect } from 'react'


import { Button, Space, message } from 'antd';

const waitTime = (time = 100) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(true);
        }, time);
    });
};

const convertArrayToObject = (array) => {
    let retArr = [];
    var object = array.reduce(
        (obj, item) => Object.assign(obj, { [item.id]: { 'text': item.description } }), {});
    return object;

};


const EditableFgBudget = (props) => {
    const [editableKeys, setEditableRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [accountingItems, setAccountingItems] = useState([]);
    const [dataSource, setDataSource] = useState([]);
    const [projectId, setProjectId] = useState(props.projectId);
    const [fgBudgetId, setFgBudgetId] = useState(props.fgBudgetId);
    const { t } = useTranslation();
    const defaultData = props.data;
    const year = props.year;

    console.log(dataSource);
    console.log(defaultData)

    const formatDigit = (num) => {
        try {
            return num.toFixed(2);
        }
        catch {
            return num;
        }
    }
    const loadAccountingItems = React.useCallback(async () => {
        let promise;
        promise = getFgAccountingItems();

        if (!promise) {
            return;
        }
        setLoading(true);
        

        promise.then(response => {
            setAccountingItems(convertArrayToObject(response, 'id'))

        }).catch(error => {
            setLoading(false)
        });
    }, [])

    useEffect(() => {
        loadAccountingItems();
    }, [loadAccountingItems]);

    console.log(accountingItems)

    const processAccObj = (accObj) => {
        console.log(accObj);
        let arObj = [];
        accObj.forEach(element => {
            let acId = 0;
            if (element.hasOwnProperty('accountingItemId')) {
                console.log(parseInt(element.accountingItem));
                acId = isNaN(parseInt(element.accountingItem)) ? element.accountingItemId : parseInt(element.accountingItem);
                console.log(acId);
            }
                arObj.push({
                    'fgBudgetId': fgBudgetId,
                    'projectId': projectId,
                    'accountingItemId': acId,
                    'daysWorkerBudget': parseFloat(element.daysWorkerBudget),
                    // 'daysHelper': parseFloat(element.daysHelperBudget),
                    'customItem': element.accountingItemId == 0 ? element.accountingItem : "",
                    'customType': element.accountingItemId == 0 ? 1 : 0,
                    'actual': 0,
                    'actualSelected': 0,
                    'budget': 1
                })
        });
        let promise;
        console.log(arObj);
        promise = addFgAccountingItems(
            {
                "id" : fgBudgetId,
                "fachGroupCalculationList": arObj
            }
           );
        if (!promise) {
            return;
        }
        // let screenState = {
        //     "year": year.toString(),
        //     "tab": '2'
        // }
        promise.then(response => {
            message.success("Accounting items saved")
            // props.reloadProject(screenState);
        }).catch(error => {
            message.error("Accounting items not saved")
        });
    }


    const columns = [
        {
            title: t("calculation.accounting_item"),
            dataIndex: 'accountingItemName',
            editable: props.fgBudgetPhase === 1 ? true : false,
            valueType: 'select',
            valueEnum: accountingItems,
            width: '42%',
            fieldProps: { placeholder: '' },
            // renderFormItem: () => [<ProFormSelect  align={'middle'} placeholder={0.0}></ProFormSelect>],
            formItemProps: (form, { rowIndex }) => {
                return {
                    rules: rowIndex > -1 ? [{ required: true, message: 'Artikel erforderlich' }] : [],
                };
            },
        },
       
        {
            title: t("calculation.helper"),
            align: "right",
            editable: props.fgBudgetPhase === 1 ? true : false,
            dataIndex: 'daysWorkerBudget',
            fieldProps: { placeholder: 0 },
            valueType: 'inputnumber',
            // renderFormItem: () => [<ProFormDigit placeholder={0.0}></ProFormDigit>],
            fieldProps: { placeholder: 0 },
            render: (text, row, index) => {
                return (
                    <span><b>
                        {text != null || text == 0 ? formatDigit(text) : "0.00"}
                    </b>
                    </span>
                )
            },
            // formItemProps: (form, { rowIndex }) => {
            //     return {
            //         rules: [
            //             // {
            //             //     required: true,
            //             // },
            //             // () => ({
            //             //     validator(_, value) {
            //             //         if (isNaN(value)) {
            //             //             return Promise.reject("Has to be a number.");
            //             //         }
            //             //         return Promise.resolve();
            //             //     }
            //             // })
            //         ]
            //     };
            // },
        },
        {
            title: t("calculation.helper"),
            align: "right",
            editable: props.fgBudgetPhase != 1 ? true : false,
            dataIndex: 'daysWorkerActual',
            // renderFormItem: () => [<ProFormDigit placeholder={0.0}></ProFormDigit>],
            fieldProps: { placeholder: 0 },
            render: (text, row, index) => {
                return (
                    <span><b>
                        {text != null || text == 0 ? formatDigit(text) : "0.00"}
                    </b>
                    </span>
                )
            },
            // formItemProps: (form, { rowIndex }) => {
            //     return {
            //         rules: [
            //             // {
            //             //     required: true,
            //             // },
            //             // () => ({
            //             //     validator(_, value) {
            //             //         if (isNaN(value)) {
            //             //             return Promise.reject("Has to be a number.");
            //             //         }
            //             //         return Promise.resolve();
            //             //     }
            //             // })
            //         ]
            //     };
            // },
        },
        

        {
            title: 'Action',
            valueType: 'option',
            width: 70,
            fieldProps: {
            },
            render: (text, record, _, action) => [

                <a key="editable" onClick={() => {
                    var _a;
                    (_a = action === null || action === void 0 ? void 0 : action.startEditable) === null || _a === void 0 ? void 0 : _a.call(action, record.key);

                }}>
                    <EditTwoTone />
                </a>,
                <a key="delete" onClick={() => {
                    setDataSource(dataSource.filter((item) => item.key !== record.key));
                }}>
                    <DeleteTwoTone />
                </a>,

            ],
        },

    ];
    let locale = {
        emptyText: (
            <span>
                <p>
                    Keine Daten
                </p>
            </span>
        )
    };
    return (

        <div> 
            <EditableProTable
                toolBarRender={() => [<Button icon={<SaveOutlined />} onClick={() => processAccObj(dataSource)}>Speichern</Button>]}
                rowKey="key"
                size={"small"}
                bordered
                maxLength={50}
                locale={locale}
                recordCreatorProps={{
                    position: 'bottom',
                    creatorButtonText: "Neuer Eintrag",
                    message: "No",
                    record: () => ({ key: (Math.random() * 1000000).toFixed(0) }),
                }
                }
                columns={columns}
                request={async () => ({
                    data: defaultData,
                    total: 50,
                    success: true,
                })}
                value={dataSource}
                onChange={setDataSource}
                columnEmptyText={<Button></Button>}
                editable={{
                    type: 'multiple',
                    cancelText: <CloseCircleTwoTone/> ,
                    saveText: <SaveOutlined />,
                    deleteText: "Löschen",
                    deletePopconfirmMessage: 'Diese Zeile löschen?',
                    onlyAddOneLineAlertMessage: "Fügen Sie jeweils eine Zeile hinzu",
                    editableKeys,
                    onSave: async (rowKey, data, row) => {
                        await waitTime(200);
                    },
                    onChange: setEditableRowKeys,
                    actionRender: (row, config, dom) => [dom.save, dom.cancel,],
                    // actionRender: (row, config, dom) => [dom.save, dom.cancel, <Button >New</Button>],
                }} /> 
            <div style={{ alignItems: 'right', margin: '10' }}> </div>
        </div>
    );
};

export default EditableFgBudget;